(function () {
  const overlay = document.createElement('div');
  overlay.className = 'ca-video-overlay';
  overlay.innerHTML = `
    <div class="ca-video-overlay__inner">
      <button class="ca-video-overlay__close" aria-label="Close video">&times;</button>
      <iframe
        class="ca-video-overlay__iframe"
        src=""
        allow="autoplay; encrypted-media"
        allowfullscreen
      ></iframe>
    </div>
  `;
  document.body.appendChild(overlay);

  const iframe = /** @type {HTMLIFrameElement} */ (overlay.querySelector('.ca-video-overlay__iframe'));
  const closeBtn = /** @type {HTMLButtonElement} */ (overlay.querySelector('.ca-video-overlay__close'));

  /**
   * @param {string} url
   * @returns {string}
   */
  function getEmbedUrl(url) {
    const match = url.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/)([a-zA-Z0-9_-]{11})/);
    if (match) {
      return `https://www.youtube.com/embed/${match[1]}?autoplay=1&rel=0`;
    }
    return url;
  }

  /**
   * @param {string} url
   */
  function openVideo(url) {
    iframe.src = getEmbedUrl(url);
    overlay.classList.add('is-active');
    document.body.style.overflow = 'hidden';
  }

  function closeVideo() {
    overlay.classList.remove('is-active');
    iframe.src = '';
    document.body.style.overflow = '';
  }

  closeBtn.addEventListener('click', closeVideo);

  overlay.addEventListener('click', function (e) {
    if (e.target === overlay) closeVideo();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeVideo();
  });

  document.addEventListener('click', function (e) {
    const target = /** @type {HTMLElement} */ (e.target);
    const trigger = target.closest('.ca-video-trigger');
    if (trigger) {
      e.preventDefault();
      const url = /** @type {HTMLElement} */ (trigger).dataset.videoUrl || '';
      if (url) openVideo(url);
    }
  });
})();